"use client";
import React from "react";
import "@/app/resourcepage.css";

const BannerImage = () => {
  return (
    <div className="sliderinnner2">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="banner_video"
        width={555}
        height={350}
      >
        <source src="/video/Camera_tampering_detection.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default BannerImage;
